var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['base_btn', _vm.direction, _vm.color, { disable: _vm.disable }],on:{"click":_vm.action}},[_c('div',{class:['arrow', _vm.direction]}),_vm._v(" "),_c('div',{staticClass:"ctn"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }